<template>
    <v-container fluid fill-height>
        <Toolbar
            :moduleColor="moduleColor"
            :show="show"
            :anyLoading="anyLoading"
            :response="responses[tab] ?? null"
            @input-default-data="inputDefaultData"
            @toggle-input-form="toggleInputForm"
        />
        <v-row justify="center" v-show="show.inputForm">
            <v-col cols="6" align-self="center">
                <InputForm
                    :forms="forms"
                    :stations="stations"
                    :loading="loading"
                    :anyLoading="anyLoading"
                    :rules="rules"
                    :valid="valid"
                    :minDateTime="minDateTime"
                    :maxDateTime="maxDateTime"
                    @submit="handleSubmit"
                    @update:valid="valid = $event"
                    @add-form="addForm"
                    @remove-form="removeForm"
                    @add-multiple-forms="addMultipleForms"
                />
            </v-col>
        </v-row>
        <v-row v-if="!show.inputForm && responses" no-gutters justify="center">
            <v-col cols="12" md="12">
                <v-card>
                    <v-tabs
                        v-model="tab"
                        :background-color="moduleColor"
                        dark
                        grow
                        show-arrows
                    >
                        <v-tab
                            v-for="(response, responseIndex) in responses"
                            :key="responseIndex"
                            v-if="response && response.order"
                        >
                            {{
                                response.order.station?.Name ||
                                    'Unknown Station'
                            }}
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item
                            v-for="(response, responseIndex) in responses"
                            :key="responseIndex"
                            :value="responseIndex"
                            v-if="response && response.order"
                        >
                            <v-card-title>
                                Runout Analysis
                                {{ response.order.station.Name }}
                                <v-tooltip
                                    bottom
                                    v-if="
                                        response?.reportedRunoutDateTime &&
                                            response?.order?.StStart
                                    "
                                >
                                    <template #activator="{ on, attrs }">
                                        <v-chip
                                            v-bind="attrs"
                                            v-on="on"
                                            label
                                            class="mx-2"
                                            dark
                                            :color="
                                                compareDates(
                                                    response.reportedRunoutDateTime,
                                                    response.order.StStart
                                                ) < 1
                                                    ? 'red'
                                                    : 'green'
                                            "
                                        >
                                            Did it run out?&nbsp;
                                            <b>
                                                {{
                                                    compareDates(
                                                        response.reportedRunoutDateTime,
                                                        response.order.StStart
                                                    ) < 1
                                                        ? 'Yes'
                                                        : 'No'
                                                }}
                                            </b>
                                        </v-chip>
                                    </template>
                                    Reported runout time:
                                    {{
                                        formatHumanReadableDateTime(
                                            response.reportedRunoutDateTime
                                        )
                                    }}
                                    <br />
                                    Arrival time:
                                    {{
                                        formatHumanReadableDateTime(
                                            response.order.StStart
                                        )
                                    }}
                                </v-tooltip>
                                <div
                                    v-show="
                                        response?.consumptionSpikes?.length > 0
                                    "
                                >
                                    <template
                                        v-for="consumptionSpike in response.consumptionSpikes"
                                    >
                                        <v-tooltip
                                            v-if="
                                                consumptionSpike?.spikes
                                                    ?.length > 0
                                            "
                                            :key="consumptionSpike.product"
                                            bottom
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-chip
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    label
                                                    color="teal"
                                                    dark
                                                >
                                                    Found consumption spikes for
                                                    {{
                                                        consumptionSpike.product
                                                    }}
                                                </v-chip>
                                            </template>
                                            <v-list
                                                dense
                                                dark
                                                color="transparent"
                                            >
                                                <v-list-item
                                                    v-for="spike in consumptionSpike.spikes"
                                                    :key="spike.date"
                                                >
                                                    {{ spike.date }} -
                                                    {{ spike.percentage }}
                                                </v-list-item>
                                            </v-list>
                                        </v-tooltip>
                                    </template>
                                </div>
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    :color="moduleColor"
                                    @click="openOrderDetailsDialog(response)"
                                >
                                    <v-icon left>mdi-table</v-icon>
                                    Show Order Details & Readings
                                </v-btn>
                                <v-btn
                                    text
                                    :color="moduleColor"
                                    @click="
                                        openConsumptionAveragesDialog(response)
                                    "
                                >
                                    <v-icon left>mdi-data-export</v-icon>
                                    Show Consumption Averages
                                </v-btn>
                            </v-card-title>
                            <v-card-text>
                                <v-expansion-panels v-model="orderPanel">
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <span
                                                class="text-left text-uppercase text-h6"
                                            >
                                                Order information #{{
                                                    response.order.OrderID
                                                }}
                                            </span>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                v-if="
                                                    response.order.LoadNumOrd >
                                                        1
                                                "
                                                label
                                                color="warning"
                                                class="ma-2"
                                            >
                                                SPLIT ORDER #{{
                                                    response.order.LoadNumOrd
                                                }}
                                            </v-btn>
                                            <v-btn
                                                v-if="
                                                    response.order
                                                        .OrderStatus ===
                                                        'PRLDISPAT'
                                                "
                                                label
                                                color="warning"
                                                class="ma-2"
                                            >
                                                PREDISPATCH
                                            </v-btn>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row>
                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                        v-model="
                                                            response.order
                                                                .ShiftDetail
                                                        "
                                                        label="Shift Detail"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                        v-model="
                                                            response.order
                                                                .OrderID
                                                        "
                                                        label="Order ID"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        label="Order Status"
                                                        :value="
                                                            orderStatusText(
                                                                response.order
                                                            )
                                                        "
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        v-model="
                                                            response.order
                                                                .terminal
                                                                .TerminalName
                                                        "
                                                        label="Terminal"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-text-field
                                                        v-model="
                                                            response.order
                                                                .station.Name
                                                        "
                                                        label="Station"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                        v-model="
                                                            response.order
                                                                .LoadNum
                                                        "
                                                        label="Load Number"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="12" md="3">
                                                    <v-text-field
                                                        v-model="
                                                            response.order
                                                                .LoadNumOrd
                                                        "
                                                        label="Split Load Number"
                                                        placeholder="N/A"
                                                        readonly
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                                <v-row>
                                    <v-col cols="12" md="12">
                                        <v-card>
                                            <v-card-title
                                                class="text-uppercase"
                                            >
                                                Time comparison
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    :color="moduleColor"
                                                    text
                                                    @click="
                                                        show.datapoints = !show.datapoints
                                                    "
                                                >
                                                    <v-icon left>
                                                        mdi-timeline
                                                    </v-icon>
                                                    {{
                                                        show.datapoints
                                                            ? 'Hide'
                                                            : 'Show'
                                                    }}
                                                    time data
                                                </v-btn>
                                            </v-card-title>
                                            <v-card-text>
                                                <v-simple-table>
                                                    <template #default>
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th
                                                                    class="text-left font-weight-bold text-uppercase text-h6"
                                                                >
                                                                    <v-icon
                                                                        left
                                                                        color="error"
                                                                    >
                                                                        mdi-clock-alert
                                                                    </v-icon>
                                                                    Client
                                                                    Reported
                                                                </th>
                                                                <th
                                                                    class="text-left font-weight-bold text-uppercase text-h6"
                                                                >
                                                                    <v-icon
                                                                        left
                                                                        color="teal"
                                                                    >
                                                                        mdi-clock
                                                                    </v-icon>
                                                                    UPT Actual
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    class="text-left text-h6 font-weight-bold text-uppercase"
                                                                >
                                                                    <v-tooltip
                                                                        top
                                                                    >
                                                                        <template
                                                                            #activator="{ on, attrs }"
                                                                        >
                                                                            <span
                                                                                v-bind="
                                                                                    attrs
                                                                                "
                                                                                v-on="
                                                                                    on
                                                                                "
                                                                                style="cursor: help;"
                                                                            >
                                                                                Arrival
                                                                                time
                                                                                <v-icon
                                                                                    left
                                                                                    color="info"
                                                                                    x-small
                                                                                >
                                                                                    mdi-help
                                                                                </v-icon>
                                                                            </span>
                                                                        </template>
                                                                        <span
                                                                            class="white--text"
                                                                        >
                                                                            The
                                                                            datetime
                                                                            (MM-DD-YYYY
                                                                            HH:MM
                                                                            AM/PM)
                                                                            of
                                                                            when
                                                                            the
                                                                            vehicle
                                                                            arrived
                                                                            at
                                                                            the
                                                                            station
                                                                        </span>
                                                                    </v-tooltip>
                                                                </td>
                                                                <td
                                                                    class="text-left text-body-1 red--text text--lighten-2"
                                                                >
                                                                    {{
                                                                        formatHumanReadableDateTime(
                                                                            response.reportedDeliveryDateTime
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="text-left text-body-1 teal--text text--lighten-2"
                                                                >
                                                                    {{
                                                                        formatHumanReadableDateTime(
                                                                            response
                                                                                .realDurations
                                                                                .stationStart
                                                                        )
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td
                                                                    class="text-left text-h6 font-weight-bold text-uppercase"
                                                                >
                                                                    <v-tooltip
                                                                        top
                                                                        right
                                                                    >
                                                                        <template
                                                                            #activator="{ on, attrs }"
                                                                        >
                                                                            <span
                                                                                v-bind="
                                                                                    attrs
                                                                                "
                                                                                v-on="
                                                                                    on
                                                                                "
                                                                                style="cursor: help;"
                                                                            >
                                                                                Travel
                                                                                time
                                                                                <v-icon
                                                                                    left
                                                                                    color="info"
                                                                                    x-small
                                                                                >
                                                                                    mdi-help
                                                                                </v-icon>
                                                                            </span>
                                                                        </template>
                                                                        <span
                                                                            class="white--text"
                                                                        >
                                                                            The
                                                                            travel
                                                                            time
                                                                            (Xh
                                                                            Xm).
                                                                            Is
                                                                            the
                                                                            time
                                                                            difference
                                                                            of
                                                                            when
                                                                            the
                                                                            vehicle
                                                                            arrived
                                                                            at
                                                                            the
                                                                            terminal
                                                                            and
                                                                            when
                                                                            the
                                                                            order
                                                                            was
                                                                            reported
                                                                            to
                                                                            arrive
                                                                            at
                                                                            the
                                                                            station
                                                                        </span>
                                                                    </v-tooltip>
                                                                </td>
                                                                <td
                                                                    class="text-left text-body-1 red--text text--lighten-2"
                                                                >
                                                                    <v-tooltip
                                                                        top
                                                                    >
                                                                        <template
                                                                            #activator="{ on, attrs }"
                                                                        >
                                                                            <span
                                                                                v-bind="
                                                                                    attrs
                                                                                "
                                                                                v-on="
                                                                                    on
                                                                                "
                                                                                style="cursor: help;"
                                                                            >
                                                                                {{
                                                                                    formatIndependentTime(
                                                                                        getDifference(
                                                                                            response
                                                                                                .realDurations
                                                                                                .terminalStart,
                                                                                            response.reportedDeliveryDateTime
                                                                                        )
                                                                                    )
                                                                                }}
                                                                                <v-icon
                                                                                    left
                                                                                    color="info"
                                                                                    x-small
                                                                                >
                                                                                    mdi-help
                                                                                </v-icon>
                                                                            </span>
                                                                        </template>
                                                                        <span
                                                                            class="white--text"
                                                                        >
                                                                            The
                                                                            date
                                                                            &
                                                                            time
                                                                            when
                                                                            the
                                                                            order
                                                                            was
                                                                            reported
                                                                            to
                                                                            be
                                                                            delivered
                                                                            at
                                                                            the
                                                                            station
                                                                        </span>
                                                                    </v-tooltip>
                                                                </td>
                                                                <td
                                                                    class="text-left text-body-1 teal--text text--lighten-2"
                                                                >
                                                                    {{
                                                                        formatIndependentTime(
                                                                            getDifference(
                                                                                response
                                                                                    .realDurations
                                                                                    .terminalStart,
                                                                                response
                                                                                    .realDurations
                                                                                    .stationStart
                                                                            )
                                                                        )
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                                <v-divider
                                                    class="my-4"
                                                ></v-divider>
                                                <v-simple-table
                                                    style="border-color: aqua;"
                                                >
                                                    <template #default>
                                                        <thead>
                                                            <tr>
                                                                <th
                                                                    class="text-left text-h6 font-weight-bold text-uppercase"
                                                                >
                                                                    Product
                                                                </th>
                                                                <th
                                                                    class="text-left text-h6 font-weight-bold text-uppercase"
                                                                >
                                                                    Client
                                                                    Reported RO
                                                                </th>
                                                                <th
                                                                    class="text-left text-h6 font-weight-bold text-uppercase"
                                                                >
                                                                    Inventory RO
                                                                </th>
                                                                <th
                                                                    class="text-left text-h6 font-weight-bold text-uppercase"
                                                                >
                                                                    UPT
                                                                    Forecasted
                                                                    RO
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr
                                                                v-for="orderDetail in response
                                                                    .order
                                                                    .order_details"
                                                            >
                                                                <td
                                                                    class="text-left text-h6"
                                                                >
                                                                    {{
                                                                        orderDetail
                                                                            .product
                                                                            .Product
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="text-left red--text text--lighten-2"
                                                                >
                                                                    {{
                                                                        formatHumanReadableDateTime(
                                                                            response.reportedRunoutDateTime
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="text-left teal--text text--lighten-2"
                                                                >
                                                                    {{
                                                                        formatHumanReadableDateTime(
                                                                            orderDetail.latestRunoutDateTime
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="text-left deep-orange--text text--lighten-2"
                                                                >
                                                                    {{
                                                                        formatHumanReadableDateTime(
                                                                            orderDetail
                                                                                .rundown
                                                                                .run_out_at
                                                                        )
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <TimeComparisonGraph
                                            :moduleColor="moduleColor"
                                            :response="response"
                                        ></TimeComparisonGraph>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-2" v-show="show.datapoints">
                                    <v-col cols="12" md="4">
                                        <v-card>
                                            <v-card-title>
                                                Real data
                                            </v-card-title>
                                            <v-card-text>
                                                Terminal Duration:
                                                {{
                                                    response.realDurations
                                                        .terminalToTerminal
                                                }}<br />
                                                Terminal to Station Duration:
                                                {{
                                                    response.realDurations
                                                        .terminalToStation
                                                }}<br />
                                                Station Duration:
                                                {{
                                                    response.realDurations
                                                        .stationToStation
                                                }}
                                                <v-divider></v-divider>
                                                Terminal start time:
                                                {{
                                                    response.realDurations
                                                        .terminalStart
                                                }}<br />
                                                Terminal end time:
                                                {{
                                                    response.realDurations
                                                        .terminalEnd
                                                }}<br />
                                                <v-divider></v-divider>
                                                Station start time:
                                                {{
                                                    response.realDurations
                                                        .stationStart
                                                }}<br />
                                                Station end time:
                                                {{
                                                    response.realDurations
                                                        .stationEnd
                                                }}
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-card>
                                            <v-card-title>
                                                Forecasted data
                                            </v-card-title>
                                            <v-card-text>
                                                Terminal Duration:
                                                {{
                                                    response.averageDurations
                                                        .terminalToTerminal
                                                }}<br />
                                                Terminal to Station Duration:
                                                {{
                                                    response.averageDurations
                                                        .terminalToStation
                                                }}<br />
                                                Station Duration:
                                                {{
                                                    response.averageDurations
                                                        .stationToStation
                                                }}
                                                <v-divider></v-divider>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-card>
                                            <v-card-title>
                                                Reported data
                                            </v-card-title>
                                            <v-card-text>
                                                Reported runout time:
                                                {{
                                                    formatDateTime(
                                                        response.reportedRunoutDateTime
                                                    )
                                                }}
                                                <br />
                                                Reported delivery time:
                                                {{
                                                    formatDateTime(
                                                        response.reportedDeliveryDateTime
                                                    )
                                                }}
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row class="mt-2">
                                    <v-col cols="12" md="12">
                                        <VolumeGraph
                                            :moduleColor="moduleColor"
                                            :responseIndex="responseIndex"
                                            :orderDetails="
                                                response.order.order_details
                                            "
                                            @consumptionSpikesDetected="
                                                handleConsumptionSpikes(
                                                    $event,
                                                    responseIndex
                                                )
                                            "
                                        ></VolumeGraph>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
            <v-dialog
                v-model="orderDetailsDialog"
                v-if="selectedResponse && selectedResponse.order"
            >
                <v-card>
                    <v-card-title>
                        Order Details & Readings
                    </v-card-title>
                    <v-card-text>
                        <v-expansion-panels v-model="orderDetailsPanel">
                            <v-expansion-panel
                                v-for="(orderDetail,
                                orderDetailIndex) in selectedResponse.order
                                    .order_details"
                                :key="orderDetailIndex"
                            >
                                <v-expansion-panel-header>
                                    Order Detail #{{ orderDetailIndex + 1 }} -
                                    {{ orderDetail.product.Product }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-chip
                                        label
                                        color="teal"
                                        outlined
                                        small
                                        class="my-1 mr-1"
                                    >
                                        Safe Fill:

                                        <b>
                                            {{
                                                orderDetail.productDetails
                                                    .total_safe_fill
                                            }}</b
                                        >
                                    </v-chip>
                                    <v-chip
                                        label
                                        color="red"
                                        outlined
                                        small
                                        class="my-1 mr-1"
                                    >
                                        Safe Pump:
                                        <b>
                                            {{
                                                orderDetail.productDetails
                                                    .total_safe_pump
                                            }}
                                        </b>
                                    </v-chip>
                                    <v-chip
                                        label
                                        color="info"
                                        outlined
                                        small
                                        class="my-1 mr-1"
                                    >
                                        Daily average consumption:
                                        {{
                                            getAverageConsumption(
                                                null,
                                                orderDetail.averageConsumptions,
                                                'daily'
                                            )
                                        }}
                                    </v-chip>

                                    <v-data-table
                                        :headers="filteredReadingsHeaders"
                                        :items="orderDetail.readings"
                                        :items-per-page="-1"
                                        fixed-header
                                        height="50vh"
                                    >
                                        <template #top>
                                            <v-toolbar
                                                dark
                                                flat
                                                dense
                                                :color="moduleColor"
                                            >
                                                <v-toolbar-title
                                                    class="text-uppercase"
                                                >
                                                    Readings
                                                </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    dark
                                                    plain
                                                    small
                                                    @click="
                                                        showConsumptionColumns = !showConsumptionColumns
                                                    "
                                                >
                                                    {{
                                                        showConsumptionColumns
                                                            ? 'Hide'
                                                            : 'Show'
                                                    }}
                                                    Consumption Columns
                                                </v-btn>
                                            </v-toolbar>
                                        </template>
                                        <template
                                            #item.InventoryDttm="{ item }"
                                        >
                                            {{
                                                formatHumanReadableDateTime(
                                                    item.InventoryDttm
                                                )
                                            }}
                                        </template>
                                        <template #item.total_volume="{ item }">
                                            <v-icon
                                                v-if="
                                                    item.total_volume <=
                                                        parseInt(
                                                            orderDetail
                                                                .productDetails
                                                                .total_safe_pump
                                                        ) +
                                                            500
                                                "
                                                color="error"
                                            >
                                                mdi-alert-circle
                                            </v-icon>
                                            <span
                                                :style="
                                                    `color: ${getTrafficLightColor(
                                                        orderDetail
                                                            .productDetails
                                                            .total_safe_fill,
                                                        orderDetail
                                                            .productDetails
                                                            .total_safe_pump,
                                                        item.total_volume
                                                    )}`
                                                "
                                            >
                                                {{ item.total_volume }}
                                            </span>
                                        </template>

                                        <template
                                            #item.forecasted_volume="{ item, index }"
                                        >
                                            <span
                                                :style="
                                                    `color: ${getTrafficLightColor(
                                                        orderDetail
                                                            .productDetails
                                                            .total_safe_fill,
                                                        orderDetail
                                                            .productDetails
                                                            .total_safe_pump,
                                                        findForecastedVolume(
                                                            selectedResponse.order,
                                                            orderDetailIndex,
                                                            item.InventoryDttm,
                                                            'forecasted_volume'
                                                        )
                                                    )}`
                                                "
                                            >
                                                {{
                                                    findForecastedVolume(
                                                        selectedResponse.order,
                                                        orderDetailIndex,
                                                        item.InventoryDttm,
                                                        'forecasted_volume'
                                                    )
                                                }}
                                            </span>
                                        </template>

                                        <!-- New template for displaying the volume minus the hourly average from the previous row
                                        <template
                                            #item.estimated_volume="{ item, index }"
                                        >
                                            {{
                                                calculateEstimatedVolume(
                                                    orderDetailIndex,
                                                    item.InventoryDttm,
                                                    index
                                                )
                                            }}
                                        </template>-->

                                        <!-- New column to display the difference between original total_volume and estimated_volume -->
                                        <template
                                            #item.volume_difference="{ item, index }"
                                        >
                                            <span
                                                :style="
                                                    `color: ${getTrafficLightColor(
                                                        0,
                                                        1000,
                                                        calculateVolumeDifference(
                                                            item.total_volume,
                                                            findForecastedVolume(
                                                                selectedResponse.order,
                                                                orderDetailIndex,
                                                                item.InventoryDttm,
                                                                'forecasted_volume'
                                                            )
                                                        )
                                                    )}`
                                                "
                                            >
                                                {{
                                                    calculateVolumeDifference(
                                                        item.total_volume,
                                                        findForecastedVolume(
                                                            selectedResponse.order,
                                                            orderDetailIndex,
                                                            item.InventoryDttm,
                                                            'forecasted_volume'
                                                        )
                                                    )
                                                }}
                                            </span>
                                        </template>
                                        <template
                                            #item.consumption="{ item, index }"
                                        >
                                            <div v-if="index !== 0">
                                                <span
                                                    v-if="
                                                        orderDetail.readings[
                                                            index - 1
                                                        ].total_volume -
                                                            item.total_volume >=
                                                            0
                                                    "
                                                >
                                                    {{
                                                        orderDetail.readings[
                                                            index - 1
                                                        ].total_volume -
                                                            item.total_volume
                                                    }}
                                                </span>
                                                <span v-else>
                                                    REFUEL
                                                </span>
                                            </div>
                                        </template>
                                        <template
                                            #item.forecasted_consumption="{ item }"
                                        >
                                            <v-tooltip
                                                bottom
                                                dark
                                                :min-width="600"
                                            >
                                                <template
                                                    #activator="{ on, attrs }"
                                                >
                                                    <span
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon
                                                            small
                                                            color="teal"
                                                            right
                                                        >
                                                            mdi-chart-timeline-variant-shimmer
                                                        </v-icon>
                                                        {{
                                                            hourlyConsumption(
                                                                orderDetail.averageConsumptions,
                                                                item.InventoryDttm,
                                                                orderDetail.ProductType
                                                            ).toFixed(0)
                                                        }}
                                                    </span>
                                                </template>
                                                <span>
                                                    Forecasted consumption data:
                                                    <v-list dark dense>
                                                        <v-list-item
                                                            v-for="(value,
                                                            key) in hourlyConsumption(
                                                                orderDetail.averageConsumptions,
                                                                item.InventoryDttm,
                                                                orderDetail.ProductType,
                                                                true
                                                            )"
                                                            :key="key"
                                                        >
                                                            <v-list-item-content>
                                                                {{ key }}:
                                                            </v-list-item-content>
                                                            <v-list-item-content
                                                                class="align-end green--text"
                                                            >
                                                                <span>
                                                                    <v-icon
                                                                        color="success"
                                                                    >
                                                                        {{
                                                                            key ==
                                                                            'Total'
                                                                                ? 'mdi-equal'
                                                                                : 'mdi-plus'
                                                                        }}
                                                                    </v-icon>
                                                                    {{
                                                                        value.toFixed(
                                                                            2
                                                                        )
                                                                    }}
                                                                </span>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </span>
                                            </v-tooltip>
                                        </template>
                                        <template
                                            #item.consumption_difference="{ item, index }"
                                        >
                                            <span
                                                v-if="index !== 0"
                                                :style="
                                                    `color: ${getTrafficLightColor(
                                                        0,
                                                        1000,
                                                        calculateVolumeDifference(
                                                            orderDetail
                                                                .readings[
                                                                index - 1
                                                            ].total_volume -
                                                                item.total_volume,
                                                            hourlyConsumption(
                                                                orderDetail.averageConsumptions,
                                                                item.InventoryDttm,
                                                                orderDetail.ProductType
                                                            ).toFixed(0)
                                                        )
                                                    )}`
                                                "
                                            >
                                                {{
                                                    calculateVolumeDifference(
                                                        orderDetail.readings[
                                                            index - 1
                                                        ].total_volume -
                                                            item.total_volume,
                                                        hourlyConsumption(
                                                            orderDetail.averageConsumptions,
                                                            item.InventoryDttm,
                                                            orderDetail.ProductType
                                                        ).toFixed(0)
                                                    )
                                                }}
                                            </span>
                                        </template>
                                    </v-data-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog
                v-model="stationConsumptionAveragesDialog"
                v-if="selectedResponse && selectedResponse.order"
            >
                <v-card>
                    <v-card-title>Station Consumption Averages</v-card-title>
                    <v-card-text>
                        <v-row
                            v-for="orderDetail in selectedResponse.order
                                .order_details"
                            :key="orderDetail.OrderProdID"
                        >
                            <v-col
                                v-for="periodType in periodTypes"
                                :key="periodType"
                            >
                                <v-card>
                                    <v-card-title>
                                        {{
                                            orderDetail.product.Product +
                                                ' - ' +
                                                periodType
                                        }}
                                    </v-card-title>
                                    <v-data-table
                                        :headers="[
                                            {
                                                text: 'Period Time',
                                                value: 'period_value'
                                            },
                                            {
                                                text: 'Average Consumption',
                                                value: 'average_consumption'
                                            },
                                            {
                                                text: 'Factor',
                                                value: 'factor'
                                            }
                                        ]"
                                        :items="
                                            averageConsumptionsByPeriodType(
                                                orderDetail,
                                                periodType
                                            )
                                        "
                                        :sort-by="['period_value']"
                                        :items-per-page="-1"
                                        fixed-header
                                        height="50vh"
                                    ></v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import Toolbar from '../../components/Administration/RunoutAnalysis/Toolbar.vue';
import InputForm from '../../components/Administration/RunoutAnalysis/InputForm.vue';
import OrderDetailsDialog from '../../components/Administration/RunoutAnalysis/OrderDetailsDialog.vue';

import VolumeGraph from '../../components/Administration/RunoutAnalysis/VolumeGraph.vue';

import { validations } from '@/Utils/validation';

import { dateUtils } from '../../components/mixins/dateUtils';
import { colorUtils } from '../../components/mixins/colorUtils';

import { apiService } from '../../components/services/apiService';
import TimeComparisonGraph from '../../components/Administration/RunoutAnalysis/TimeComparisonGraph.vue';
export default {
    name: 'RunoutAnalysis',
    components: {
        Toolbar,
        InputForm,
        VolumeGraph,
        TimeComparisonGraph,
        OrderDetailsDialog
    },
    mixins: [dateUtils, colorUtils],
    data() {
        return {
            tab: null,
            loading: {
                stations: true,
                report: false
            },
            moduleColor: 'purple',
            valid: false,
            rules: validations,
            forms: [],
            show: {
                inputForm: true,
                differences: false,
                datapoints: false,
                readings: false
            },
            departureDateTime: null,
            arrivalDateTime: null,
            averageTimes: [],
            responses: [],
            selectedResponse: null,
            fuel: {
                dailyAverageConsumption: null,
                hourlyAverageConsumptions: [],
                last48HoursReadings: []
            },
            reportedVsRealArrivalDateTimeDifference: null,
            file: null,
            stations: [],
            minDateTime: new Date(Date.now() - 157680000000)
                .toISOString()
                .substr(0, 10),
            maxDateTime: new Date().toISOString().split('T')[0],

            //RunoutAnalysis Card
            orderPanel: null,

            //Readings Card
            orderDetailsPanel: 0,
            orderDetailRundownPanel: null,
            showConsumptionColumns: true, // Controls the visibility of the columns
            readingsHeaders: [
                { text: 'Datetime', value: 'InventoryDttm' },
                { text: 'Actual Volume', value: 'total_volume' },
                { text: 'Forecasted Volume', value: 'forecasted_volume' },
                {
                    text: 'Actual VS. Forecast volume difference',
                    value: 'volume_difference'
                },
                // Consumption columns that will be toggled
                {
                    text: 'Actual consumption',
                    value: 'consumption',
                    show: true
                },
                {
                    text: 'Forecasted consumption',
                    value: 'forecasted_consumption',
                    show: true
                },
                {
                    text: 'Actual VS. Forecast consumption difference',
                    value: 'consumption_difference',
                    show: true
                }
            ],
            rundownHeaders: [
                { text: 'Datetime', value: 'forecasted_timestamp' },
                { text: 'Forecasted Volume', value: 'forecasted_volume' }
            ],

            orderDetailsDialog: false,
            stationConsumptionAveragesDialog: false,
            periodTypes: ['weekly', 'last-15-days-hourly', 'day-of-week'],
            consumptionSpikes: []
        };
    },
    computed: {
        anyLoading() {
            return Object.values(this.loading).some(value => value);
        },
        filteredReadingsHeaders() {
            return this.readingsHeaders.filter(header => {
                if (
                    [
                        'consumption',
                        'forecasted_consumption',
                        'consumption_difference'
                    ].includes(header.value)
                ) {
                    return this.showConsumptionColumns;
                }
                return true;
            });
        }
    },
    watch: {
        /**form: {
            handler: function() {
                this.$refs.form.validate();
            },
            deep: true
        }*/
    },

    mounted() {
        this.getStations();
    },

    methods: {
        openOrderDetailsDialog(response) {
            this.selectedResponse = response;
            this.orderDetailsDialog = true;
        },
        openConsumptionAveragesDialog(response) {
            this.selectedResponse = response;
            this.stationConsumptionAveragesDialog = true;
        },
        stationItemText(station) {
            return `${station.Name} - #${station.StationNumber ?? 'N/A'}`;
        },
        orderStatusText(order) {
            return `${order.OrderStatus} - ${order.OrdLoadStatus}`;
        },

        async getStations() {
            this.loading.stations = true;
            try {
                this.stations = await apiService.getStations();
            } catch (error) {
                console.error(error);
            } finally {
                this.loading.stations = false;
            }
        },
        async handleSubmit() {
            console.log('Handle submit');
            this.loading.report = true;
            this.responses = []; // Clear previous responses if needed
            try {
                // Iterate through each form entry and execute the request
                for (const formItem of this.forms) {
                    const response = await apiService.runAnalysis(formItem);
                    if (response && response.order) {
                        if (this.show.inputForm === true) {
                            this.show.inputForm = false;
                        }
                        // Ensure required fields are not null or undefined before adding
                        this.responses.push({
                            ...response,
                            reportedRunoutDateTime:
                                response.reportedRunoutDateTime ?? null,
                            consumptionSpikes: response.consumptionSpikes ?? [],
                            order: response.order
                        });
                    } else {
                        console.warn('Invalid or empty response', response);
                    }
                }
                this.show.inputForm = false;
            } catch (error) {
                console.error('Error during analysis', error);
            } finally {
                this.loading.report = false;
            }
        },
        // Add a new form
        addForm() {
            this.forms.push({
                station: null,
                reportedRunoutDateTime: null,
                reportedDeliveryDateTime: null,
                penalty: null
            });
        },
        // Remove a form by index
        removeForm(index) {
            this.forms.splice(index, 1);
        },
        // Add multiple forms (from Excel upload)
        addMultipleForms(newForms) {
            this.forms.push(...newForms);
        },
        inputDefaultData() {
            this.forms = [
                {
                    station: {
                        StationID: 4695,
                        Name: 'CK 52582 - ESSO - TORONTO',
                        StationNumber: 852582,
                        id: 4695
                    },
                    reportedDeliveryDateTime: '2024-09-25T23:14',
                    reportedRunoutDateTime: '2024-09-25T21:53',
                    penalty: 185
                }
            ];
        },
        toggleInputForm() {
            this.show.inputForm = !this.show.inputForm;
        },
        parseDuration(duration) {
            if (!duration) {
                return 0; // If the duration is missing, return 0
            }
            const [hours, minutes, seconds] = duration.split(':').map(Number);
            return (hours * 3600 + minutes * 60 + seconds) * 1000;
        },

        estimatedArrivalDateTime(
            realDurations,
            averageDurations,
            timeFormat = 'YYYY-MM-DD HH:mm:ss'
        ) {
            const terminalStart = realDurations.terminalStart
                ? new Date(realDurations.terminalStart)
                : new Date(); // Fallback to the current time if `terminalStart` is missing

            const terminalToTerminalDuration = this.parseDuration(
                averageDurations.terminalToTerminal
            );
            const terminalToStationDuration = this.parseDuration(
                averageDurations.terminalToStation
            );

            const estimatedArrival = new Date(
                terminalStart.getTime() +
                    terminalToTerminalDuration +
                    terminalToStationDuration
            );

            return this.formatDateTime(estimatedArrival, timeFormat);
        },
        totalEstimatedTravelTime(averageDurations) {
            const terminalToTerminalDuration = this.parseDuration(
                averageDurations.terminalToTerminal
            );
            const terminalToStationDuration = this.parseDuration(
                averageDurations.terminalToStation
            );

            const totalDurationInMilliseconds =
                terminalToTerminalDuration + terminalToStationDuration;

            // Convert the total duration back to HH:MM:SS format
            const totalHours = Math.floor(
                totalDurationInMilliseconds / (1000 * 60 * 60)
            );
            const totalMinutes = Math.floor(
                (totalDurationInMilliseconds / (1000 * 60)) % 60
            );
            const totalSeconds = Math.floor(
                (totalDurationInMilliseconds / 1000) % 60
            );

            return `${String(totalHours).padStart(2, '0')}:${String(
                totalMinutes
            ).padStart(2, '0')}:${String(totalSeconds).padStart(2, '0')}`;
        },
        isDifferencePositive(start, end) {
            if (!start || !end) {
                return true; // If one of the values is missing, assume positive difference
            }
            const diff = new Date(end).getTime() - new Date(start).getTime();
            return diff >= 0;
        },
        // Helper function to extract the appropriate period value based on the datetime and period type
        getPeriodValue(datetime, period_type) {
            if (!datetime) {
                return null; // If datetime is missing, return null
            }

            const date = new Date(datetime);

            switch (period_type) {
                case 'hourly':
                    return String(date.getHours()).padStart(2, '0');
                case 'daily':
                    return 'daily';
                default:
                    return null;
            }
        },

        // Function to get the average consumption based on datetime and period type
        getAverageConsumption(
            datetime = null,
            averageConsumptions,
            period_type
        ) {
            let periodValue = null;

            if (datetime) {
                periodValue = this.getPeriodValue(datetime, period_type);
            }

            if (!periodValue && period_type !== 'daily') {
                return null; // If datetime is not provided and period type is not daily, return null
            }

            const consumptionRecord = averageConsumptions.find(record => {
                if (period_type === 'daily') {
                    return (
                        record.period_type === period_type &&
                        record.period_value === 'daily'
                    );
                }

                if (datetime) {
                    return (
                        record.period_type === period_type &&
                        record.period_value === periodValue
                    );
                } else {
                    return record.period_type === period_type;
                }
            });

            return consumptionRecord
                ? parseFloat(consumptionRecord.average_consumption)
                : null;
        },
        // Calculate the estimated volume by subtracting the hourly average from the previous row
        calculateEstimatedVolume(
            order,
            orderDetailIndex,
            inventoryDttm,
            index
        ) {
            const currentItem =
                order.order_details[orderDetailIndex].readings[index];
            const previousItem =
                order.order_details[orderDetailIndex].readings[index - 1];

            if (!previousItem || index === 0) {
                return currentItem.total_volume; // If it's the first item or previous is missing, return the current volume
            }

            const hourlyAverage = this.getAverageConsumption(
                inventoryDttm,
                order.order_details[orderDetailIndex].averageConsumptions,
                'hourly'
            );

            if (!hourlyAverage) {
                return currentItem.total_volume; // If the average is missing, return the current volume
            }

            return previousItem.total_volume - hourlyAverage;
        },

        // Calculate the difference between original total_volume and estimated_volume
        calculateVolumeDifference(totalVolume, estimatedVolume) {
            if (
                totalVolume === null ||
                estimatedVolume === null ||
                totalVolume === 0 ||
                estimatedVolume === 0
            ) {
                return 0; // If either value is missing, return 0
            }
            const difference =
                parseInt(estimatedVolume) - parseInt(totalVolume);
            return difference.toFixed(0);
        },
        findForecastedVolume(
            order,
            orderDetailIndex,
            inventoryDttm,
            fieldName
        ) {
            const roundedDttm = this.roundToNearestHour(inventoryDttm);
            const rundownData =
                order.order_details[orderDetailIndex].rundown.simulation_data;

            if (!rundownData || rundownData.length === 0) {
                return 0; // If the rundown data is missing, return 0
            }

            const matchingForecast = rundownData.find(
                forecast => forecast.forecasted_timestamp === roundedDttm
            );

            return matchingForecast ? matchingForecast[fieldName] || 0 : 0;
        },

        hourlyConsumption(
            consumptions,
            datetime,
            productId,
            returnAverages = false
        ) {
            const hour = new Date(datetime).getHours(); // Extract the hour from the datetime
            const dayOfWeek = new Date(datetime).toLocaleString('en-US', {
                weekday: 'long'
            }); // Get the day of the week
            const weekOfYear = new Date(datetime).getWeekOfYear();

            // Find the matching hourly consumption and factors
            const last15DaysHourly = consumptions.find(
                c =>
                    c.product_id === productId &&
                    c.period_type === 'last-15-days-hourly' &&
                    c.period_value === hour.toString().padStart(2, '0')
            );
            const dayOfWeekFactor = consumptions.find(
                c =>
                    c.product_id === productId &&
                    c.period_type === 'day-of-week' &&
                    c.period_value === `${dayOfWeek}`
            );
            const weeklyFactor = consumptions.find(
                c =>
                    c.product_id === productId &&
                    c.period_type === 'weekly' &&
                    c.period_value === 'Week ' + weekOfYear
            );

            // Check if the required data is available
            if (!last15DaysHourly || !dayOfWeekFactor || !weeklyFactor) {
                console.error(
                    'Missing data for hourly consumption calculation',
                    last15DaysHourly,
                    dayOfWeekFactor,
                    weeklyFactor
                );
                return 0; // If any of the factors are missing, return 0
            }
            // Calculate the hourly consumption using the formula
            const last15DaysHourlyConsumption = parseFloat(
                last15DaysHourly.average_consumption
            );
            const dayFactor = parseFloat(dayOfWeekFactor.factor);
            const weekFactor = parseFloat(weeklyFactor.factor);

            let dayOfWeekScale = dayFactor * last15DaysHourlyConsumption;
            dayOfWeekScale -= last15DaysHourlyConsumption;
            let weeklyScale = weekFactor * last15DaysHourlyConsumption;
            weeklyScale -= last15DaysHourlyConsumption;

            if (returnAverages) {
                return {
                    'Day of Week': dayOfWeekScale,
                    Week: weeklyScale,
                    'Last 15 Days': last15DaysHourlyConsumption,
                    Total:
                        last15DaysHourlyConsumption +
                        dayOfWeekScale +
                        weeklyScale
                };
            }
            return last15DaysHourlyConsumption + dayOfWeekScale + weeklyScale;
        },

        // Function to calculate daily consumption by aggregating hourly consumptions
        dailyConsumption(consumptions, date, productId) {
            let totalDailyConsumption = 0;

            // Loop through all 24 hours of the day
            for (let hour = 0; hour < 24; hour++) {
                const datetime = new Date(date);
                datetime.setHours(hour); // Set the hour for each iteration
                const hourlyConsumption = this.hourlyConsumption(
                    consumptions,
                    datetime,
                    productId
                );

                totalDailyConsumption += hourlyConsumption;
            }

            return totalDailyConsumption;
        },
        averageConsumptionsByPeriodType(orderDetail, periodType) {
            if (!orderDetail || !periodType) {
                console.error('Missing order detail or period type');
                return null;
            }

            let averageConsumptions = orderDetail.averageConsumptions.filter(
                record => record.period_type === periodType
            );

            if (averageConsumptions.length === 0) {
                console.error(
                    'No average consumption data found for',
                    periodType
                );
                return null;
            }
            return averageConsumptions;
        },

        handleConsumptionSpikes(spikesData, responseIndex) {
            console.log('Received consumption spikes data:', spikesData);

            if (!spikesData || spikesData.length === 0) {
                return;
            }

            // Ensure the responseIndex is valid
            if (this.responses[responseIndex]) {
                this.$set(
                    this.responses[responseIndex],
                    'consumptionSpikes',
                    spikesData
                );
            } else {
                console.warn(`Response index ${responseIndex} is not valid.`);
            }
        }
    }
};
</script>
